var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPartners(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.141002 5.37396C0.0227357 5.28979 -0.027827 5.14151 0.0151242 5.00482L0.07107 4.83392C0.111973 4.69886 0.234944 4.60324 0.378772 4.59466L4.84745 4.24602L6.56079 0.219636C6.61826 0.0785835 6.76251 -0.00989148 6.91745 0.000885211H7.09927C7.24533 -0.00214419 7.3773 0.085684 7.42795 0.219636L9.14829 4.24602L13.617 4.59466C13.7608 4.60324 13.8838 4.69886 13.9247 4.83392L13.9806 5.00482C14.0282 5.1372 13.9863 5.28453 13.8757 5.37396L10.505 8.20405L11.54 12.4492C11.5741 12.5851 11.5218 12.7277 11.4071 12.8115L11.2043 12.9209C11.086 12.999 10.931 12.999 10.8127 12.9209L7.00836 10.665L3.18306 12.9414C3.06476 13.0195 2.90973 13.0195 2.79144 12.9414L2.63759 12.8388C2.52293 12.7551 2.47062 12.6124 2.50472 12.4765L3.51174 8.20405L0.141002 5.37396Z",
    fill: "#05C1FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartners);
export default __webpack_public_path__ + "static/media/partners.f45b50ba.svg";
export { ForwardRef as ReactComponent };